export const gNotificationAllListener = '__ALL__';

export function Notification() {
  this.mListeners = [];
}

Notification.prototype.addListener = function(pListener) {
  if(pListener) {
    this.mListeners.push(pListener);
  }
};

Notification.prototype.removeListener = function(pListener) {
  const _lIndex = this.mListeners.indexOf(pListener);
  if(_lIndex != -1) {
    this.mListeners.splice(_lIndex, 1);
  }
};

Notification.prototype.notify = function(pCallback) {
  const _lParams = Array.prototype.slice.call(arguments, 1);
  this.mListeners.forEach(function(pListener) {
    if(pListener.hasOwnProperty(pCallback) && pListener[pCallback] != undefined) {
      pListener[pCallback].apply(pListener, _lParams);
    }

    if (pListener.hasOwnProperty(gNotificationAllListener) && pListener[gNotificationAllListener] != undefined) {
      // Note: The 'all' listener enables us to intercept any notification on an item.
      pListener[gNotificationAllListener].apply(pListener, [pCallback, ..._lParams]);
    }
  });
};
